module.exports = __webpack_public_path__ + "img/silh_with_neck.b556f9a4.png";